module.exports = __webpack_public_path__ + "img/productinfo-3.6f53a161.jpg";